module.exports = __webpack_public_path__ + "img/6.7b938487.jpeg";